import React from 'react'

import styled from '@emotion/styled'
import sv from '../styles/styles'
import AuthBase from '../components/AuthBase'
import AuthButton from '../components/AuthButton'
import AuthError from '../components/AuthError'
import {CardElement, useElements, useStripe} from '@stripe/react-stripe-js'
import {useHistory} from "react-router-dom";

import {useDispatch, useSelector} from 'react-redux';

import {alertActions, userActions} from '../_actions';

import {useTranslation} from "react-i18next";
import LinearProgress from "@material-ui/core/LinearProgress";
import {makeStyles} from "@material-ui/styles";
import {alertActionTypes} from "../_constants";
import {AnimatedLoader} from "../styles/CommonStyler";
import {authenticationState} from "../_constants/commons/authenticationState";

// STYLE ##########################################################

const Actions = styled(`div`)`
  margin-top: 24px;
  ${sv.flexRow};
`;

const Loading = styled('div')`
    margin-bottom: 20px;
    margin-top: 20px;
    height: 5px;
`;

const Section = styled('div')`
    margin-bottom: 20px;
`;

const IsVerifying = styled(`div`)`
  width: 100%;
  height: 48px;
  color: ${sv.colors.cta};
  ${sv.flexCenter};
  h3 {
    margin-right: 16px;
  }
`;

// COMPONENT ##########################################################

export const PaymentForm = (props) => {
    // ----------------- hooks -----------------------
    const history = useHistory();
    const {t} = useTranslation();

    // Stripe hooks
    const stripe = useStripe();
    const elements = useElements();

    // Redux hooks
    const dispatch = useDispatch();
    const {alert, authentication, payment} = useSelector(state => {
        const { users, alert, authentication } = state;
        const { payment } = users;

        return {
            payment,
            alert,
            authentication
        };
    });

    const {parent} = props;

    // ----------------- functions -----------------------
    const submit = async (event) => {
        event.preventDefault();

        const cardElement = elements.getElement(CardElement);
        const {error, token} = await stripe.createToken(cardElement);

        if (token && parent && parent === 'register') {
            props.sbtHandler(token.id);
        } else if (token){
            dispatch( userActions.setPayment(token) );
        } else {
            let msg;
            if (error && error.message) {
                msg = error.message;
            } else {
                msg = t("Sorry, we weren't able to update your payment information. Please try again.");
            }
            dispatch( alertActions.error({errorMsg: msg}) );
        }
    };

    const cancel = (e) => {
        e.preventDefault();

        if (parent && parent === 'register') {
            props.cancelHandler();
        } else {
            history.goBack();
        }
    };

    // ----------------- render -----------------------
    const classes = makeStyles({
        root: {
            flexFlow: 1,
        }
    });

    return (
        <AuthBase title={t('Payment Information')}>
            {
                alert && alert.type === alertActionTypes.ERROR &&
                <Section>
                    <AuthError error={alert.message.errorMsg}/>
                </Section>
            }
            <CardElement />
            <Loading className={classes.root}>
                { payment && payment.loading && <LinearProgress color='secondary' />}
            </Loading>
            <Actions>
                <AuthButton cancel onClick={(e) => cancel(e)}>{t('Cancel')}</AuthButton>
                <AuthButton onClick={submit} id="submit">{t('Submit')}</AuthButton>
            </Actions>

            {authentication && authentication.authState===authenticationState.CREATING_ACCOUNT &&
            <IsVerifying>
                <h3>{t('Creating Account')}</h3>
                <AnimatedLoader color={sv.colors.cta}/>
            </IsVerifying>
            }

        </AuthBase>
    );
};
